import React, { useState } from 'react';

const WalletTest: React.FC = () => {
  const [keyword, setKeyword] = useState('2MO6nkAO');
  const [securityKey, setSecurityKey] = useState('wallet');
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<any>(null);
  
  const API_BASE = 'https://t7d9a6p352.execute-api.ap-southeast-2.amazonaws.com/prod';
  
  const testWalletPreview = async () => {
    setLoading(true);
    try {
      // Open in new tab - the API will show a preview page
      window.open(`${API_BASE}/wallet/${keyword}`, '_blank');
      setResponse({ message: 'Preview opened in new tab' });
    } catch (error: any) {
      setResponse({ error: error.message });
    }
    setLoading(false);
  };
  
  const testAppleWallet = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/wallet/${securityKey}/${keyword}`, {
        headers: {
          'User-Agent': 'Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15'
        }
      });
      
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${keyword}.pkpass`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        setResponse({ message: 'Apple Pass downloaded' });
      } else {
        const data = await res.json();
        setResponse(data);
      }
    } catch (error: any) {
      setResponse({ error: error.message });
    }
    setLoading(false);
  };
  
  const testGoogleWallet = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/wallet/${securityKey}/${keyword}`, {
        headers: {
          'User-Agent': 'Mozilla/5.0 (Linux; Android 10) AppleWebKit/537.36'
        }
      });
      
      if (res.redirected) {
        window.open(res.url, '_blank');
        setResponse({ message: 'Redirected to Google Wallet' });
      } else {
        const data = await res.json();
        if (data.saveUrl) {
          window.open(data.saveUrl, '_blank');
          setResponse({ message: 'Google Wallet save URL opened' });
        } else {
          setResponse(data);
        }
      }
    } catch (error: any) {
      setResponse({ error: error.message });
    }
    setLoading(false);
  };
  
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Wallet API Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Test Configuration</h2>
        <div>
          <label>
            Keyword (param2): 
            <input 
              type="text" 
              value={keyword} 
              onChange={(e) => setKeyword(e.target.value)}
              style={{ marginLeft: '10px', padding: '5px' }}
            />
          </label>
        </div>
        <div style={{ marginTop: '10px' }}>
          <label>
            Security Key (param1): 
            <input 
              type="text" 
              value={securityKey} 
              onChange={(e) => setSecurityKey(e.target.value)}
              style={{ marginLeft: '10px', padding: '5px' }}
            />
          </label>
        </div>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Test URLs</h2>
        <ul>
          <li>Preview: <code>{API_BASE}/wallet/{keyword}</code></li>
          <li>Direct: <code>{API_BASE}/{securityKey}/{keyword}</code></li>
          <li>Apple: <code>{API_BASE}/apple/{keyword}</code></li>
          <li>Google: <code>{API_BASE}/google/{keyword}</code></li>
        </ul>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Test Actions</h2>
        <button 
          onClick={testWalletPreview} 
          disabled={loading}
          style={{ marginRight: '10px', padding: '10px 20px' }}
        >
          Open Preview Page
        </button>
        <button 
          onClick={testAppleWallet} 
          disabled={loading}
          style={{ marginRight: '10px', padding: '10px 20px' }}
        >
          Test Apple Pass
        </button>
        <button 
          onClick={testGoogleWallet} 
          disabled={loading}
          style={{ padding: '10px 20px' }}
        >
          Test Google Pass
        </button>
      </div>
      
      {response && (
        <div style={{ 
          marginTop: '20px', 
          padding: '15px', 
          backgroundColor: '#f5f5f5', 
          borderRadius: '5px' 
        }}>
          <h3>Response</h3>
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}
      
      <div style={{ marginTop: '40px', padding: '20px', backgroundColor: '#e8f4f8', borderRadius: '5px' }}>
        <h3>How it works:</h3>
        <ol>
          <li>The backend API runs on AWS API Gateway (not localhost)</li>
          <li>Your React frontend (localhost:3000) makes HTTP requests to the API</li>
          <li>The API generates passes and returns them or redirects to wallet apps</li>
          <li>In production, add2wallet.link will redirect to this API with TLS fingerprints</li>
        </ol>
        
        <h3>Current Status:</h3>
        <p>✅ API is deployed at: {API_BASE}</p>
        <p>✅ Test data inserted for keyword: 2MO6nkAO</p>
        <p>⚠️ Single parameter route (/wallet/keyword) needs backend fix</p>
        <p>✅ Two parameter route (/wallet/security/keyword) should work</p>
      </div>
    </div>
  );
};

export default WalletTest;